import { baseApi } from '../baseApi';

const BASE = '/student/vocabulary';

export const vocabularyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Translate a word / short phrase (max 100 chars)
    translateWord: builder.mutation({
      query: (body) => ({
        url: `${BASE}/translate`,
        method: 'POST',
        body,
      }),
    }),

    // Save a word to memories (upsert)
    saveVocabularyMemory: builder.mutation({
      query: (body) => ({
        url: `${BASE}/memories`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['VocabularyMemory', 'VocabularyMemoryStats'],
    }),

    // List saved words (paginated + search + sort)
    getVocabularyMemories: builder.query({
      query: (params = {}) => ({
        url: `${BASE}/memories`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((m) => ({ type: 'VocabularyMemory', id: m._id })),
              { type: 'VocabularyMemory', id: 'LIST' },
            ]
          : [{ type: 'VocabularyMemory', id: 'LIST' }],
    }),

    // Check if a single word is saved
    checkVocabularyMemory: builder.query({
      query: (word) => ({
        url: `${BASE}/memories/check`,
        params: { word },
      }),
      providesTags: (result, error, word) => [
        { type: 'VocabularyMemory', id: `check-${(word || '').toLowerCase()}` },
      ],
    }),

    // Delete by id
    deleteVocabularyMemoryById: builder.mutation({
      query: (id) => ({
        url: `${BASE}/memories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VocabularyMemory', 'VocabularyMemoryStats'],
    }),

    // Delete by word string
    deleteVocabularyMemoryByWord: builder.mutation({
      query: (word) => ({
        url: `${BASE}/memories/word/${encodeURIComponent(word)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VocabularyMemory', 'VocabularyMemoryStats'],
    }),

    // Aggregated stats
    getVocabularyMemoryStats: builder.query({
      query: () => `${BASE}/memories/stats`,
      providesTags: ['VocabularyMemoryStats'],
    }),
  }),
});

export const {
  useTranslateWordMutation,
  useSaveVocabularyMemoryMutation,
  useGetVocabularyMemoriesQuery,
  useLazyGetVocabularyMemoriesQuery,
  useCheckVocabularyMemoryQuery,
  useLazyCheckVocabularyMemoryQuery,
  useDeleteVocabularyMemoryByIdMutation,
  useDeleteVocabularyMemoryByWordMutation,
  useGetVocabularyMemoryStatsQuery,
} = vocabularyApi;
